"use client";

import { content, technologies } from "../../data/siteData";

const TechnologiesSection = ({ locale }) => {
  return (
    <section
      id="technologies"
      className="w-full py-16 md:py-24 px-6 md:px-12 bg-[#f5f5f5]"
    >
      <div className="max-w-7xl mx-auto flex flex-col gap-10 md:gap-16">
        <h2 className="font-poppins font-extralight text-4xl md:text-5xl lg:text-[64px] text-[#333333] text-left leading-none">
          {content[locale].technologies.heading}
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:flex lg:flex-wrap justify-center gap-8 md:gap-16 lg:gap-24">
          {technologies.map((tech) => (
            <div
              key={tech.name}
              className="flex flex-col items-center gap-3 md:gap-4 group"
            >
              <tech.icon
                className="text-5xl md:text-6xl lg:text-[80px] text-[#333333] group-hover:scale-110 transition-transform duration-300"
                aria-hidden="true"
              />
              <p className="font-poppins font-light text-base md:text-lg lg:text-xl text-[#555555] text-center">
                {tech.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologiesSection;
